import { DeleteWorkScheduleSlotEventOccurence } from '@/components/modals/delete-work-schedule-slot-recurrence-modal/delete-work-schedule-slot-recurrence-modal.viewmodel';
import { WorkScheduleSlotSequence } from '@/hooks/queries/use-get-office-work-schedules-slots';
import { useWorkScheduleSlotReccurenceExampleItems } from '../add-office-work-schedule-slot-form/use-work-schedule-slot-recurrence-example-items';

export const useDeleteWorkScheduleSlotRecurrenceFormViewModel = ({
  occurrence,
  sequence,
}: {
  occurrence: DeleteWorkScheduleSlotEventOccurence;
  sequence: WorkScheduleSlotSequence;
}) => {
  const { exampleItems } = useWorkScheduleSlotReccurenceExampleItems({
    startAt: occurrence.start,
    periodOfTheDay: sequence.periodOfTheDay,
    frequency: sequence.rrule!.interval ? 'weekly' : 'every-2-weeks',
  });

  return {
    exampleItems,
  };
};
